<div class="flex flex-column border-bottom-1 surface-border p-6">
  <h3>Mes applications connectées</h3>
</div>
<hr>
<div class="w-full surface-border py-4">
  <div class="list-applications">
    <p class="mb-4">
      Afin d'améliorer votre suivi et d'enrichir le contenu disponible sur cette plateforme, vous pouvez dès maintenant relier les comptes avec nos applications. Ces applications nécessitent cependant d'<b>avoir déja eu un premier rendez-vous avec notre intervenant</b>.
      <br><br>
      Si cela n'est pas encore le cas, prenez des maintenant rendez-vous en cliquant juste ici : <p-button label="Prendre rendez-vous" styleClass="p-button-link" [routerLink]="['/app/meetings']"></p-button>
    </p>
    <div *ngFor="let app of filteredApplications()" class="card shadow-2 p-4 w-100">
      <div class="flex flex-col sm:flex-row align-items-center">
        <div class="flex align-items-center w-full">
          <span class="w-16 h-16 mr-3 rounded-2xl bg-primary text-white flex items-center justify-center text-xl font-bold shrink-0 shadow-sm" [title]="app.name">
            {{ getInitials(app.name) }}
          </span>
          <div>
            <h4 class="text-left">{{ app.name }}</h4>
            <p class="text-left text-sm text-700 mt-2">{{ app.description }}</p>
          </div>
        </div>
        <div class="sm:ml-auto mt-4 sm:mt-0 min-w-[150px]">
          <div *ngIf="app.connected" class="text-right">
            <p class="text-sm text-green-600 my-2 "><b><u>Dossier n° :</u> {{ app.folderNumber }}</b></p>
            <!-- <button pButton label="Delier mon dossier" icon="pi pi-times" class="p-button-danger" (click)="disconnect(app)"></button> -->
          </div>
          <div *ngIf="!app.connected" class="text-right">
            <button pButton label="Lier mon dossier" icon="pi pi-link" class="p-button-success" (click)="connect(app)"></button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-create-external-link-dialog
  [(visible)]="displayModal"
  [app]="selectedApp"
  (created)="onCreated($event)"
  (cancelled)="onCancelled()"
  >
</app-create-external-link-dialog>